import { useLayoutEffect } from "react";

function setMeta(name, content) {
    if (!content) return;
    let el = document.querySelector(`meta[name="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function setOg(prop, content) {
    if (!content) return;
    let el = document.querySelector(`meta[property="${prop}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute("property", prop);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function removeOg(prop) {
    const el = document.querySelector(`meta[property="${prop}"]`);
    if (el) el.parentNode.removeChild(el);
}

function setCanonical(href) {
    let el = document.querySelector('link[rel="canonical"]');
    if (!href) {
        if (el) el.parentNode.removeChild(el);
        return;
    }
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

const DEFAULT_TITLE =
    "HAZ Insulation | Spray Foam, Blown-In & Attic Systems · Chicagoland & NW Indiana";
const DEFAULT_DESC =
    "HAZ Insulation — spray foam, blown-in, attic, crawl space & air-sealing experts serving Chicago Southland and Northwest Indiana. NICOR & ComEd rebate partner.";

function setJsonLd(jsonLd) {
    document
        .querySelectorAll('script[type="application/ld+json"][data-seo="1"]')
        .forEach((el) => el.parentNode.removeChild(el));
    if (!jsonLd) return;
    const items = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
    items.filter(Boolean).forEach((obj) => {
        const el = document.createElement("script");
        el.setAttribute("type", "application/ld+json");
        el.setAttribute("data-seo", "1");
        el.text = JSON.stringify(obj);
        document.head.appendChild(el);
    });
}

function applySeo({ title, description, canonical, jsonLd }) {
    const finalTitle = title || DEFAULT_TITLE;
    const finalDesc = description || DEFAULT_DESC;
    document.title = finalTitle;
    setMeta("description", finalDesc);
    setOg("og:title", finalTitle);
    setOg("og:description", finalDesc);
    setOg("og:type", "website");
    if (canonical) {
        setCanonical(canonical);
        setOg("og:url", canonical);
    } else {
        setCanonical(null);
        removeOg("og:url");
    }
    setJsonLd(jsonLd);
}

export function useSeo({ title, description, canonical, jsonLd } = {}) {
    // useLayoutEffect runs synchronously after DOM mutations so the prerender
    // crawler can observe the updated <title>/meta/canonical before snapshotting.
    useLayoutEffect(() => {
        // No-op when caller passes nothing (e.g. detail pages on an unknown
        // slug, just before <Navigate> redirects). Keeps hook order stable
        // without overwriting whatever <head> already says.
        if (
            title === undefined &&
            description === undefined &&
            canonical === undefined &&
            jsonLd === undefined
        ) {
            return undefined;
        }
        applySeo({ title, description, canonical, jsonLd });
        return () => {
            applySeo({});
        };
    }, [title, description, canonical, jsonLd]);
}
